var React = require('react');

function MoviesInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"strokeLinecap":"square","x":"5","y":"25","width":"42","height":"24","rx":"4","key":0}),React.createElement("path",{"d":"M47 34.33l12-10.853v26.046L47 38.67","key":1}),React.createElement("circle",{"strokeLinecap":"square","cx":"31.5","cy":"11.5","r":"9.5","key":2}),React.createElement("circle",{"strokeLinecap":"square","cx":"15","cy":"14","r":"7","key":3}),React.createElement("path",{"strokeLinecap":"square","d":"M16 62.607L25.607 49l9.606 13.607","key":4})]));
}

MoviesInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = MoviesInline;

MoviesInline.default = MoviesInline;
